import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller.ts'

export type ChildEligibilityForm = {
  child_first_name: string
  child_last_name: string
  child_date_of_birth: string
  insurance_member_id: string
}

export default class FormChildrenEligibilityController extends Controller {
  declare childrenDataValue: {
    covered_children: ChildEligibilityForm[]
    not_found_children: ChildEligibilityForm[]
  }
  declare checkoutOutlet: CheckoutController

  static values = { childrenData: Object }
  static outlets = ['checkout']

  connect() {
    this.checkoutOutlet.onPage2()
  }

  submit(_: SubmitEvent) {
    if (!this.childrenDataValue) throw new Error('Missing children data')

    this.checkoutOutlet.setChildEligibilityForms(
      this.childrenDataValue.covered_children,
    )
  }
}
